/**
 * Dynamite brand font configuration.
 * TODO: Replace with actual Dynamite brand fonts.
 */
export default {
    heading: `'AzoSans', sans-serif`,
    body: `'AzoSans', sans-serif`
}
